import React from 'react';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import {Button} from 'scripts/components/lib/buttons/Button';
import ButtonGroup from 'scripts/components/lib/buttons/ButtonGroup';
import DateRange from 'components/lib/formElements/DateRange';
import { Tabs, Tab } from 'scripts/components/lib/buttons/Tabs';
import { Graph } from 'components/lib/buttons/IconButtons';
import Constants from 'utils/Constants';


// styles
import styles from 'styles/components/series/tabbedGraphs/graphHeader.css';

const GraphHeader = props => (
  <header className={styles.graphHeader}>
    <div className={styles.dashboard}>
      <ButtonGroup className={styles.buttonGroup} selectedValue={props.selectedUnit} onChange={props.onUnitChange}>
          <Button label={Constants.unit.day} />
          <Button label={Constants.unit.week} />
          <Button label={Constants.unit.month} />
      </ButtonGroup>
      <DateRange
        endValue={props.endValue}
        formatDate={props.formatDate}
        maxDate={props.maxDate}
        minDate={props.minDate}
        onEndChange={props.onEndChange}
        onStartChange={props.onStartChange}
        onResetDates={props.onResetDates}
        showDialog={props.showDialog}
        startValue={props.startValue}
        toggleDialog={props.toggleDialog} />
    </div>
    <nav className={styles.navigation}>
      <Tabs
        onTabChange={props.onTabChange}
        selectedTab={props.selectedTab} >
        <Tab
          isSelected={props.selectedTab === 0}
          value={0}
          label="Cumulative Sales Revenue">
          <h3 className="emPrimary">
            {(props.salesRevenue !== null) && numeral(props.salesRevenue).format('$0,0.00')}
          </h3>
        </Tab>
        <Tab
          value={1}
          isSelected={props.selectedTab === 1}
          label="Ticket Sales">
          <Graph color={props.selectedTab === 1 ? '#FFFFFF' : '#888888'}/>
        </Tab>
      </Tabs>
    </nav>
  </header>
);

GraphHeader.propTypes = {
  selectedTab: 	PropTypes.number,
  salesRevenue: PropTypes.number,
  reset: PropTypes.func,
  startValue: PropTypes.object,
  endValue: PropTypes.object,
  onStartChange: PropTypes.func,
  onEndChange: PropTypes.func,
  formatDate: PropTypes.func,
  minDate: PropTypes.object,
  maxDate: PropTypes.object
};

export default GraphHeader;
/*
endValue={this.props.endValue}
formatDate={this.props.formatDate}
maxDate={this.props.maxDate}
minDate={this.props.minDate}
onEndChange={this.props.onEndChange}
onStartChange={this.props.onStartChange}
onTabChange={this.handleTabChange}
onUnitChange={this.handleUnitChange}
reset={this.props.reset}
salesRevenue={this.props.salesRevenue}
selectedUnit={this.state.selectedUnit}
selectedTab={this.state.selectedTab}
startValue={this.props.st
*/



// WEBPACK FOOTER //
// ./src/scripts/components/series/tabbedGraphs/GraphHeader.js